export default "__VITE_ASSET__BRZjfPgj__"